import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card as MuiCard, CardContent as MuiCardContent, Typography as MuiTypography, withStyles } from '@material-ui/core';
import { getIcon } from '@kailona/core';

var styles = function styles(theme) {
  return {
    widget: {
      width: '110px',
      padding: '5px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };
};

var Card = withStyles({
  root: {
    width: '100px',
    height: '100px'
  }
})(function (props) {
  return /*#__PURE__*/React.createElement(MuiCard, props);
});
var CardContent = withStyles(function (theme) {
  return {
    root: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.whiteSmoke.main,
      cursor: 'pointer !important'
    }
  };
})(function (props) {
  return /*#__PURE__*/React.createElement(MuiCardContent, props);
});
var Typography = withStyles(function (theme) {
  return {
    root: {
      width: '100%',
      wordBreak: 'break-word',
      textAlign: 'center',
      padding: '10px 5px 5px !important',
      cursor: 'pointer !important'
    }
  };
})(function (props) {
  return /*#__PURE__*/React.createElement(MuiCardContent, props);
});

var DashboardWidget = /*#__PURE__*/function (_Component) {
  _inherits(DashboardWidget, _Component);

  var _super = _createSuper(DashboardWidget);

  function DashboardWidget() {
    _classCallCheck(this, DashboardWidget);

    return _super.apply(this, arguments);
  }

  _createClass(DashboardWidget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          name = _this$props.name,
          children = _this$props.children;
      var widgetIcon = icon && getIcon(icon, 80);
      var classes = this.props.classes;
      return /*#__PURE__*/React.createElement("div", {
        className: classes.widget
      }, /*#__PURE__*/React.createElement(Card, {
        onClick: this.props.onClick
      }, /*#__PURE__*/React.createElement(CardContent, null, widgetIcon)), /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        onClick: this.props.onClick
      }, name));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DashboardWidget;
}(Component);

_defineProperty(DashboardWidget, "propTypes", {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  name: PropTypes.string,
  children: PropTypes.object
});

var _default = withStyles(styles)(DashboardWidget);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(styles, "styles", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DashboardWidget.js");
  reactHotLoader.register(Card, "Card", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DashboardWidget.js");
  reactHotLoader.register(CardContent, "CardContent", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DashboardWidget.js");
  reactHotLoader.register(Typography, "Typography", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DashboardWidget.js");
  reactHotLoader.register(DashboardWidget, "DashboardWidget", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DashboardWidget.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/DashboardWidget.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();